import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CreateCaseFormCommand } from './create-case-form.command';

/**
 * Create Case Form Use Case
 * Creates a new case form
 */
@Injectable({ providedIn: 'root' })
export class CreateCaseFormUseCase {
  private readonly _repository = inject(CaseFormRepository);

  /**
   * Executes the use case
   * @param command The case form creation parameters
   * @returns Observable with the created form ID and initial version ID
   */
  public execute(command: CreateCaseFormCommand): Observable<{ formId: string; versionId: string }> {
    return this._repository.createCaseForm(command);
  }
}
